import type { User } from '../types';

/** Name for tables; falls back to email when the account has no display name. */
export function userDisplayName(email: string, users: User[]): string {
  const match = users.find((u) => u.email === email);
  if (!match) return email;
  const name = [match.first_name, match.last_name].filter(Boolean).join(' ').trim();
  return name || email;
}
